/* TODO REFACTORING */
import { memo, useCallback, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useClinicians from 'hooks/useClinicians';
import useCustomSelector from 'hooks/useCustomSelector';
import { cliniciansSelectors } from 'features/clinicians'

const CliniciansAutocomplete = ({ multiple = false, fullWidth = false, margin = 'none', sx, value, error, helperText, onChange }) => {
  const { getClinicians, clearLocalClinicians } = useClinicians();
  const { data, pagination } = useCustomSelector(cliniciansSelectors.getCliniciansData)
  const fetching = useCustomSelector(cliniciansSelectors.cliniciansIsFetching)
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [firstTimeOpened, setFirstTimeOpened] = useState(false);

  const fetchClinicians = useCallback((offset, query) => {
    getClinicians({ offset, query })
  },[getClinicians]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => {
    if (scrollHeight === scrollTop + offsetHeight + 100) {
      const { limit, offset, count, total_count } = pagination;

      total_count > count + offset && fetchClinicians(limit + offset);
    }
  };
  const isOptionEqualToValue = (o, v) => o.id === v.id;
  const getOptionLabel = o => `${o?.first_name} ${o?.last_name}`;
  const onOpen = () => {
    setOpen(true);
    if (!firstTimeOpened) setFirstTimeOpened(true);
  };
  const onClose = () => setOpen(false);
  const handleChange = (_, formattedValue) => {
    onChange({
      value: multiple ? _map(formattedValue, ({ id }) => id) : formattedValue?.id, 
      formattedValue, 
      error: ''
    });
    setQuery('');
  };
  const onInputChange = (_, value) => { firstTimeOpened && setQuery(value) };
  const renderInput = params => {
    return (
      <TextField
        {...params}
        label={`Select clinician${ multiple ? 's' : ''}`}
        error={error}
        margin={margin}
        helperText={helperText}
        InputProps={{
          ...params.InputProps,
          endAdornment: <>
            {fetching && <CircularProgress color="inherit" size={20} />}
            {params.InputProps.endAdornment}
          </>
        }}
      />
    );
  };

  useEffect(() => {
    let timeout;
    if (firstTimeOpened) timeout = setTimeout(() => {
      clearLocalClinicians();
      fetchClinicians(0, query);
    }, !!query ? 500 : 0);

    return () => {
      clearTimeout(timeout);
      clearLocalClinicians();
    }
  }, [fetchClinicians, clearLocalClinicians, query, firstTimeOpened]);


  return (
    <Autocomplete
      disablePortal
      multiple={multiple}
      fullWidth={fullWidth}
      sx={sx}
      id={'clinicians'}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionLabel={getOptionLabel}
      options={data}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      value={value}
      onChange={handleChange}
      loading={fetching}
      onInputChange={onInputChange}
      renderInput={renderInput}
      ListboxProps={{ onScroll: handleScroll }}
    />

  );
};

CliniciansAutocomplete.propTypes = {
  fullWidth: PropTypes.bool,
  margin: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
  onChange: PropTypes.func.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <CliniciansAutocomplete {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);